module.exports = __webpack_public_path__ + "statics/img/cate2-1@2x.58ed0663.png";